
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Слой_1","data-name":"Слой 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 322.81 322.81"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('rect',{attrs:{"width":"322.81","height":"322.81","rx":"45","fill":"#317153"}}),_c('rect',{attrs:{"x":"24.53","y":"15.43","width":"273.76","height":"273.76","rx":"15","fill":"#efefef"}}),_c('rect',{staticClass:"cls-3",attrs:{"x":"14.77","y":"28.09","width":"293.27","height":"274.68","rx":"15"}}),_c('rect',{attrs:{"y":"42.73","width":"322.81","height":"280.09","rx":"45","fill":"#26c87c"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M282.67 269a42.86 42.86 0 00-31.41-13.41 43.78 43.78 0 00-14.57 2.41 70.87 70.87 0 00-122.11 31.05q-1.1 1.55-2.1 3.15a56 56 0 0015.2 109.83h58.88v-36.62h-17.05a4 4 0 01-3.17-6.43l35.44-46.34a4 4 0 016.35 0L243.58 359a4 4 0 01-3.18 6.43h-17.05v36.64h47.81A67 67 0 00282.67 269z","transform":"translate(-43.55 -135.33)"}})])
          )
        }
      }
    